import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    rootDefaultInput: {
        height: '1.6rem'
    }
}));

export default useStyles;
